<template>
  <div>
    <multiselect
      class="form-control"
      v-model="modelo.plataforma"
      :options="datos"
      track-by="id"
      label="nombre"
      :searchable="false"
      :close-on-select="true"
      :hide-selected="true"
      :show-labels="false"
      placeholder="Seleccione..."
    ></multiselect>
  </div>
</template>

<script>
import gql from 'graphql-tag';
import { parseJsonError } from '@/components/Utils.js';
import { mapState } from 'vuex';
export default {
  props: {
    model: Object,
    default: { type: Object, required: false, default: null },
    todos: { type: Boolean, required: false, default: false },
    xdefault: { type: Number, required: false },
  },
  data() {
    return {
      datos: [],
      modelo: {
        plataforma: null,
      },
    };
  },
  watch: {
    'modelo.plataforma': function () {
      this.model.plataforma = this.modelo.plataforma;
    },
    default: function (a) {
      if (a == null) return;
      var g = this.datos.find((x) => x.plataforma == this.default.plataforma);
      if (g == null) this.datos.push({ plataforma: this.default.plataforma });
      this.modelo.plataforma = a;
    },
    xdefault: function () {
      if (this.xdefault) {
        let uni = this.datos.find((x) => x.id == this.xdefault);
        if (uni) this.modelo.plataforma = uni;
      }
    },
    UNIDAD_NEGOCIO_ID() {
      this.modelo = { plataforma: null };
      this.getDatos();
    },
  },
  computed: {
    ...mapState({
      UNIDAD_NEGOCIO_ID: (state) => state.UNIDAD_NEGOCIO_ID,
      // plataformas: (state) => {
      //   if (state.UNIDAD_NEGOCIO_ID) {
      //     return state.plataforma.items.filter((item) => item.unidad_negocio_id == state.UNIDAD_NEGOCIO_ID);
      //   }
      //   return [];
      // },
    }),
  },
  methods: {
    async getDatos() {
      var vue = this;
      const qs = gql`query { getPlataformas(estado: true,unidad_negocio_id: ${this.UNIDAD_NEGOCIO_ID}) { id nombre direccion unidad_negocio_id estado }}`;
      await this.$apollo
        .query({ query: qs })
        .then(({ data }) => {
          vue.datos = data.getPlataformas;

          if (this.todos) {
            vue.datos.push({ plataforma: 'todos' });
          }

          if (this.default) {
            this.modelo.plataforma = this.default;
            var g = vue.datos.find((x) => x.plataforma == this.default.plataforma);
            if (g == null) vue.datos.push({ plataforma: this.default.plataforma });
          } else {
            // sel anio actual
            var d = new Date();
            var a = vue.datos.find((x) => x.plataforma == d.getFullYear());
            if (a) this.modelo.plataforma = a;
          }

          if (this.xdefault) {
            let uni = this.datos.find((x) => x.id == this.xdefault);
            if (uni) this.modelo.plataforma = uni;
          }
        })
        .catch((error) => {
          window.console.error(error);
          this.$notify(parseJsonError(error, 'getPlataformas'));
        });
    },
  },
  mounted() {
    this.getDatos();
  },
};
</script>